import { render } from "./BoardDetail.vue?vue&type=template&id=5a97fee4"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__